import React from "react";
import { X } from "lucide-react";

const ROLE_META = {
  PT:  { color: "#f59e0b", stripe: "#c2410c" },
  DEF: { color: "#06b6d4", stripe: "#0e7490" },
  CEN: { color: "#3b56e0", stripe: "#1e3aab" },
  ATT: { color: "#f97316", stripe: "#b45309" },
};

function initials(name = "") {
  const parts = name.trim().split(/\s+/);
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
}

/**
 * PlayerJersey — small jersey badge + name pill drawn over the pitch.
 * Used both in read-only formation display and as content of a slot in LineupBuilder.
 */
export default function PlayerJersey({
  player,
  role,
  size = 44,
  onRemove = null,
  empty = false,
  invalid = false,
  interactive = false,
}) {
  const r = role || player?.role || "PT";
  const meta = ROLE_META[r] || ROLE_META.PT;
  const name = player?.name;
  return (
    <div className={`flex flex-col items-center ${interactive ? "cursor-grab active:cursor-grabbing" : ""}`}
         data-testid={`player-jersey-${r}`}>
      <div
        className="relative rounded-full flex items-center justify-center shadow-lg ring-2 ring-white/80"
        style={{
          width: size, height: size,
          background: empty
            ? "rgba(255,255,255,0.85)"
            : `radial-gradient(circle at 30% 30%, ${meta.color}, ${meta.stripe} 78%)`,
          border: invalid ? "2px dashed #ef4444" : "none",
        }}
      >
        {/* Diagonal stripe on jersey */}
        {!empty && (
          <div className="absolute inset-0 rounded-full overflow-hidden pointer-events-none">
            <div className="absolute inset-y-0 -left-1 w-2 rotate-12" style={{ background: "rgba(255,255,255,0.22)" }} />
          </div>
        )}
        <span className={`display font-black text-[11px] tabular-nums ${empty ? "text-slate-400" : "text-white"}`}
              style={{ textShadow: empty ? "none" : "0 1px 2px rgba(0,0,0,0.35)" }}>
          {empty ? r : initials(name)}
        </span>

        {onRemove && !empty && (
          <button
            onClick={(e) => { e.stopPropagation(); onRemove(); }}
            className="absolute -top-1 -right-1 w-4 h-4 rounded-full bg-white text-slate-700 shadow flex items-center justify-center"
            aria-label="Rimuovi"
            data-testid={`jersey-remove-${player?.id || r}`}
          >
            <X className="w-2.5 h-2.5" strokeWidth={3} />
          </button>
        )}
      </div>
      <div className="mt-1.5 rounded-md bg-white/95 shadow-sm border border-black/5 px-1.5 py-0.5 max-w-[92px] text-center">
        {empty ? (
          <div className="text-[9px] font-black uppercase tracking-widest" style={{ color: meta.color }}>{invalid ? "manca" : r}</div>
        ) : (
          <>
            <div className="text-[9px] font-black uppercase tracking-widest leading-none" style={{ color: meta.color }}>{r}</div>
            <div className="text-[11px] font-bold text-slate-900 truncate leading-tight">{name}</div>
          </>
        )}
      </div>
    </div>
  );
}
